import {
  UNSAVED_CHANGES_NAMED_INIT,
  UNSAVED_CHANGES_NAMED_SUCCESS,
  UNSAVED_CHANGES_UNNAMED_INIT,
  UNSAVED_CHANGES_UNNAMED_SUCCESS,
  UNSAVED_CHANGES_PROJECT_DETAILS_INIT,
  UNSAVED_CHANGES_PROJECT_DETAILS_SUCCESS,
  UNSAVED_CHANGES_GANTT_BY_DEP_INIT,
  UNSAVED_CHANGES_GANTT_BY_DEP_SUCCESS,
  UNSAVED_CHANGES_GANTT_NOTIFICATIONS_INIT,
  UNSAVED_CHANGES_GANTT_NOTIFICATIONS_SUCCESS,
  UNSAVED_CHANGES_GANTT_NOTIFICATIONS_UNNAMED_INIT,
  UNSAVED_CHANGES_GANTT_NOTIFICATIONS_UNNAMED_SUCCESS,
} from "./types/common-types";

export function setUnsavedChangesNamed(val) {
  return (dispatch) => {
    dispatch({ type: UNSAVED_CHANGES_NAMED_INIT });
    dispatch({ type: UNSAVED_CHANGES_NAMED_SUCCESS, val });
  };
}

export function setUnsavedChangesUnnamed(val) {
  return (dispatch) => {
    dispatch({ type: UNSAVED_CHANGES_UNNAMED_INIT });
    dispatch({ type: UNSAVED_CHANGES_UNNAMED_SUCCESS, val });
  };
}

export function setUnsavedChangesProjectDetails(val) {
  return (dispatch) => {
    dispatch({ type: UNSAVED_CHANGES_PROJECT_DETAILS_INIT });
    dispatch({ type: UNSAVED_CHANGES_PROJECT_DETAILS_SUCCESS, val });
  };
}

export function setUnsavedChangesGanttByDep(val) {
  return (dispatch) => {
    dispatch({ type: UNSAVED_CHANGES_GANTT_BY_DEP_INIT });
    dispatch({ type: UNSAVED_CHANGES_GANTT_BY_DEP_SUCCESS, val });
  };
}

export function setUnsavedChangesGanttNotifications(val) {
  return (dispatch) => {
    dispatch({ type: UNSAVED_CHANGES_GANTT_NOTIFICATIONS_INIT });
    dispatch({ type: UNSAVED_CHANGES_GANTT_NOTIFICATIONS_SUCCESS, val });
  };
}

export function setUnsavedChangesGanttNotificationsUnnamed(val) {
  return (dispatch) => {
    dispatch({ type: UNSAVED_CHANGES_GANTT_NOTIFICATIONS_UNNAMED_INIT });
    dispatch({
      type: UNSAVED_CHANGES_GANTT_NOTIFICATIONS_UNNAMED_SUCCESS,
      val,
    });
  };
}
